import { LAKH_CURRENCY_MULTIPLIER } from "@/constants";

export function salaryToLPA(salary: number) {
  return salary / LAKH_CURRENCY_MULTIPLIER;
}
